import {z} from "zod";

export const userInquiryStatusSchema = z.enum(["open", "accepted", "declined"]);

export const userInquiryStatusSchemaTranslation = {
  "open": "Offen",
  "accepted": "Akzeptiert",
  "declined": "Abgelehnt"
}

export type UserInquiryStatus = z.infer<typeof userInquiryStatusSchema>;

export const userInquirySchema = z.object({
  id: z.string(),
  appId: z.string().max(10),
  personId: z.string().optional(),
  firstName: z.string().min(2),
  lastName: z.string().min(2),
  message: z.string().min(3),
  teamId: z.number().optional(),
  status: userInquiryStatusSchema.default(userInquiryStatusSchema.enum.open),
  updatedAt: z.number(),
  updatedBy: z.string(),
  createdAt: z.number(),
  createdBy: z.string(),
})

export type UserInquiry = z.infer<typeof userInquirySchema>;

export const userInquiryCreateRequestSchema = userInquirySchema.pick({personId: true, firstName: true, lastName: true, message: true, teamId: true});
export type UserInquiryCreateRequest = z.infer<typeof userInquiryCreateRequestSchema>;

export const userInquiryUpdateStatusRequestSchema = userInquirySchema.pick({id: true, status: true});
export type UserInquiryUpdateStatusRequest = z.infer<typeof userInquiryUpdateStatusRequestSchema>;

export const userInquiryGetQuerySchema = userInquirySchema.pick({id: true});
export type UserInquiryGetQuery = z.infer<typeof userInquiryGetQuerySchema>; 
